import request from '@/utils/request'

export function fetchWeeklyDates() {
  return request({
    url: '/v1/trend-insights/dates',
    method: 'get',
  })
}

export function fetchWeekly(query) {
  return request({
    url: '/v1/trend-insights/weekly',
    method: 'get',
    params: query
  })
}